import { AxiosResponse } from "axios"
import api from "./Api"

export const logoutUser = (): Promise<AxiosResponse<any, any>> => {
    return api.post('/auth/logout')
}
export const resignUser = (): Promise<AxiosResponse<any, any>> => {
    return api.post('/auth/resign')
}